import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 47.2979,
			cy: 12.1436,
			r: 3.58696,
			stroke: "#DFE3EA",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M59.4601 14.4497L60.5278 10.9775L59.6053 10.6938L58.5376 14.166L55.2445 13.1534L54.9608 14.0759L58.2539 15.0886L57.2412 18.3818L58.1638 18.6655L59.1764 15.3722L62.6488 16.44L62.9324 15.5174L59.4601 14.4497Z",
			fill: "#DFE3EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.0131 3.11955C55.5358 2.3778 56.6967 2.65969 56.8211 3.55855L56.8828 4.00505C56.9208 4.27948 57.0709 4.52586 57.2974 4.68544L57.6658 4.94509C58.4076 5.46779 58.1257 6.62873 57.2268 6.75308L56.7803 6.81485C56.5059 6.85281 56.2595 7.00292 56.0999 7.22938L55.8403 7.59783C55.3176 8.33959 54.1566 8.0577 54.0323 7.15883L53.9705 6.71234C53.9326 6.43791 53.7825 6.19153 53.556 6.03194L53.1875 5.7723C52.4458 5.2496 52.7277 4.08865 53.6265 3.96431L54.073 3.90254C54.3475 3.86458 54.5938 3.71447 54.7534 3.48801L55.0131 3.11955Z",
			fill: "#DFE3EA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32.1185,
			cy: 39.4666,
			r: 22.1185,
			fill: "#DFE3EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.8174 28.624V39.9001H45.563",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgIcClock;
